// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-height{height:67vh;padding-top:20px!important}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Report/BalanceSheet.vue"],"names":[],"mappings":"AACA,aACI,WAAA,CACA,0BAAJ","sourcesContent":["\n.text-height {\n    height: 67vh;\n    padding-top: 20px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
